module.exports = __webpack_public_path__ + "img/4.8d58527f.png";